<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-07-27 09:24:27
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-02-22 15:34:29
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/WeMeet_admin_project/wemeet-admin/src/views/brandProduct/productList.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<template>
  <div>
    <vab-query-form>
      <!-- <vab-query-form-left-panel :span="8">
        <el-button :icon="Plus" type="primary" @click="addBrand($event)">
          添加展品
        </el-button>
      </vab-query-form-left-panel> -->
      <vab-query-form-right-panel :span="24">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="展品名称">
            <el-input v-model.trim="queryForm.likeExhibitName" clearable placeholder="请输入展品名称" />
          </el-form-item>
          <el-form-item label="展商名称">
            <el-input v-model.trim="queryForm.likeExhibitorName" clearable placeholder="请输入展商名称" />
          </el-form-item>
          <el-form-item>
            <el-button :icon="Search" type="primary" @click="queryData">查询</el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" border :data="list">
      <el-table-column label="序号" prop="exhibitId" />
      <el-table-column label="展品名称" prop="exhibitName" show-overflow-tooltip />
      <el-table-column label="排序值" prop="sort" show-overflow-tooltip />
      <el-table-column label="所属展商" prop="exhibitorName" show-overflow-tooltip />
      <el-table-column label="操作" show-overflow-tooltip width="300">
        <template #default="{ row }">
          <!-- <el-button type="info" plain @click="handleEdit(row)">编辑</el-button> -->
          <!-- <el-button type="info" plain @click="handleSort(row)">
            调整排序
          </el-button> -->
        </template>
      </el-table-column>
      <template #empty>
        <!-- <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        /> -->
        <el-empty class="vab-data-empty" description="暂无数据" />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.pageNum"
      :layout="layout"
      :page-size="queryForm.pageSize"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <edit-sort ref="editRef" @fetch-data="fetchData" />
  </div>
</template>

<script>
  import {
    defineComponent,
    defineAsyncComponent,
    getCurrentInstance,
    onMounted,
    reactive,
    toRefs,
    onActivated,
  } from 'vue'

  import { Delete, Plus, Search } from '@element-plus/icons'
  import { getAllProductList, editBrandProductStatus } from '@/api/brand'
  import { useRoute } from 'vue-router'
  export default defineComponent({
    name: 'ProductList',
    components: {
      EditSort: defineAsyncComponent(() => import('./components/editSort')),
    },
    setup() {
      const { proxy } = getCurrentInstance()
      const route = useRoute()
      const state = reactive({
        queryForm: {
          likeExhibitName: '',
          likeExhibitorName: '',
          pageNum: 1,
          pageSize: 10,
          meetingCode: route.query.meetingCode,
        },
        total: 0,
        listLoading: false,
        list: [],
        layout: 'total, sizes, prev, pager, next, jumper',
        editRef: null,
      })

      /**
       * @description: 编辑展商
       * @param {*} row
       * @return {*}
       */
      const handleEdit = (row) => {
        proxy.$router.push({
          path: '/exhibitionManage/brandProductEdit',
          query: {
            exhibitorCode: state.queryForm.exhibitorCode,
            id: row.exhibitCode,
          },
        })
      }

      const handleConfig = (row) => {
        proxy.$router.replace(`/page/pageConfigModule/${row.id}`)
      }

      const handleDelete = (row) => {
        if (row.id) {
          proxy.$baseConfirm('你确定要删除当前项吗', null, async () => {
            const { msg } = await deletePage(row.id)
            proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            await fetchData()
          })
        }
      }

      const queryData = () => {
        fetchData()
      }

      const fetchData = async () => {
        state.listLoading = true
        state.queryForm.meetingCode = route.query.meetingCode
        const { data } = await getAllProductList(state.queryForm)
        state.list = data.list
        state.total = data.total
        state.listLoading = false
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        fetchData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        fetchData()
      }

      // const productStatusChange = async (row) => {
      //   try {
      //     let obj = {
      //       exhibitCode: row.exhibitCode,
      //       status: row.status,
      //     }
      //     await editBrandProductStatus(obj)
      //     proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
      //   } catch (e) {
      //     proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
      //   }

      //   fetchData()
      // }

      onActivated(() => {
        fetchData()
      })

      const addBrand = () => {
        proxy.$router.push({
          path: '/exhibitionManage/brandProductEdit',
          query: {
            exhibitorCode: state.queryForm.exhibitorCode,
            id: 'new',
          },
        })
      }

      const handleProduct = () => {
        proxy.$router.push({
          path: '/exhibitionManage/brandEdit',
          query: {
            meetingCode: state.queryForm.meetingCode,
            id: 'new',
          },
        })
      }
      /**
       * @description: 修改排序。外侧outside 标识修改的是sort ，inside 修改的是selfSort
       * @param {*} row
       * @return {*}
       */
      const handleSort = (row) => {
        state.editRef.showEdit(row, 'outside')
      }

      return {
        ...toRefs(state),
        handleEdit,
        queryData,
        fetchData,
        handleSizeChange,
        handleCurrentChange,
        handleDelete,
        handleConfig,
        Delete,
        Search,
        Plus,
        addBrand,
        handleSort,
      }
    },
  })
</script>
<style lang="scss" scoped></style>
